<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.school.schoolName')"
                                    v-model="searchData.schoolName"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.school.nickName')"
                                    v-model="searchData.nickName"
                                />
                            </v-col>
<!--                            <v-col cols="12" md="3" sm="6" xs="3">-->
<!--                                <v-text-field-->
<!--                                    solo-->
<!--                                    hide-details-->
<!--                                    :label="$vuetify.lang.t('$vuetify.custom.school.userName')"-->
<!--                                    v-model="searchData.userName"-->
<!--                                />-->
<!--                            </v-col>-->
                            <v-col cols="12" md="6" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-btn v-5="permissionCode.search" color="primary mr-3" @click="pageChange" dark large>
                                        <v-icon left>mdi-magnify</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                    </v-btn>
                                    <v-btn v-5="permissionCode.add" color="success mr-3" @click="addDialog=true" dark large>
                                        <v-icon left>mdi-plus</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.school.add') }}
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="name"
                        class="elevation-1"
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                        <template v-slot:item.actions="{ item }">
                            <v-btn v-5="permissionCode.delete" color="normal" x-small @click="deleteItem(item)" class="ml-2">
                                <v-icon small>
                                    mdi-delete
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.deleteBtn') }}
                            </v-btn>
                            <v-btn v-5="permissionCode.update" color="normal" x-small @click="updateItem(item)" class="ml-2">
                                <v-icon small>
                                    mdi-update
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.school.update') }}
                            </v-btn>
                            <v-btn v-5="permissionCode.student" color="normal" x-small @click="studentDetail(item)" class="ml-2">
                                <v-icon small>
                                    mdi-account-supervisor
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.school.currSchoolStudent') }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
            <v-dialog v-model="dialog" persistent max-width="700px">
                <school-update v-model="dialog" :schoolMsg="schoolMsg" @initialize="pageChange"></school-update>
            </v-dialog>
            <v-dialog v-model="addDialog" persistent max-width="700px">
                <school-add v-model="addDialog" @initialize="pageChange"></school-add>
            </v-dialog>
            <v-dialog v-model="studentDialog" max-width="1000px">
                <school-student v-model="studentDialog" :schoolMsg="schoolMsg"></school-student>
            </v-dialog>
        </v-row>
    </v-container>
</template>
<style></style>
<script>
    import Mock from 'mockjs';
    import schoolUpdate from './school-update'
    import schoolAdd from './school-add'
    import schoolStudent from './school-student'

    export default {
        data() {
            return {
                permissionCode:{
                    search:'biz:school:search',
                    add:'biz:school:add',
                    delete:'biz:school:delete',
                    update:'biz:school:update',
                    student:'biz:school:student',
                },
                studentDialog: false,
                addDialog: false,
                schoolMsg: {},
                dialog: false,
                loading: true,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                selected: [],
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions:[5,10,20,50],
                    //disableItemsPerPage:true,
                },
                searchData: {
                    schoolName: '',
                    nickName:'',
                    userName: ''
                },
                options: {},
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.school.schoolName'), value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.school.nickName'), value: 'nickName',
                    },
                    // {
                    //     text: this.$vuetify.lang.t('$vuetify.custom.school.userName'), value: 'userName',
                    // },
                    {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
                ],
                totalDesserts: 0,
                desserts: [],
            }

        },
        methods: {
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            studentDetail(item) {
                this.studentDialog = true
                this.schoolMsg = item
            },
            deleteItem(item) {
                this.$dialog.confirm(this.$vuetify.lang.t('$vuetify.custom.deleteSelect'), null, () => {
                    this.$api.school.deleteSchool(item.id).then(data => {
                        if(data.flag){
                            this.initialize()
                        }
                    })
                })
            },
            updateItem(item) {
                this.dialog = true
                this.schoolMsg = item
            },
            initialize() {
                this.loading = true
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.school.getSchoolList(
                    Object.assign({}, this.searchData, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })
                // this.loading = false;
                // let data = Mock.mock({
                //     'data|10': [
                //         {
                //             'schoolName': '@cname',
                //             'userName': '@cname',
                //         }
                //     ]
                // });
                // this.desserts = data.data
                // this.totalDesserts = 10;

            },
            changeOptions(option) {
                this.initialize()
            }
        },
        components: {
            schoolUpdate, schoolAdd, schoolStudent
        },
    }
</script>
